import React, { useState, useEffect, Fragment } from "react";
import { BrowserRouter as Router, Link, useLocation } from "react-router-dom";
import { Tag } from "antd";
import "antd/dist/antd.min.css";

function GetFilterCountries({ searchCountry, isFetching, countryCode }) {
  const location = useLocation();
  const searchbrand = new URLSearchParams(location.search).get("brand") || null;
  const thisBrand = searchbrand ? `&brand=${searchbrand}` : "";

  return (
    <>
      <Link disabled={isFetching} to={`${window.location.pathname}?country=US${thisBrand}`}>
        <Tag
          className='tag-hover badge badge-light'
          style={{ fontWeight: 500, marginBottom: '5px', border: searchCountry == 'US' || !searchCountry ? '1px solid #007bff' : '1px solid #2f122e54' }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span>USA&nbsp;</span>
            <img
              style={{ width: '20px', objectFit: 'contain' }}
              loading="lazy"
              src={`https://flagcdn.com/w20/us.png`}
              srcSet={`https://flagcdn.com/w40/us.png 2x`}
              alt=""
            />
          </span>
        </Tag>
      </Link>
      <Link disabled={isFetching} to={`${window.location.pathname}?country=AE${thisBrand}`}>
        <Tag
          className='tag-hover badge badge-light'
          style={{ fontWeight: 500, marginBottom: '5px', border: searchCountry == 'AE' ? '1px solid #007bff' : '1px solid #2f122e54' }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span>UAE&nbsp;</span>
            <img
              style={{ width: '20px', objectFit: 'contain' }}
              loading="lazy"
              src={`https://flagcdn.com/w20/ae.png`}
              srcSet={`https://flagcdn.com/w40/ae.png 2x`}
              alt=""
            />
          </span>
        </Tag>
      </Link>
      <Link disabled={isFetching} to={`${window.location.pathname}?country=GB${thisBrand}`}>
        <Tag
          className='tag-hover badge badge-light'
          style={{ fontWeight: 500, marginBottom: '5px', border: searchCountry == 'GB' ? '1px solid #007bff' : '1px solid #2f122e54' }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            <span>UK&nbsp;</span>
            <img
              style={{ width: '20px', objectFit: 'contain' }}
              loading="lazy"
              src={`https://flagcdn.com/w20/gb.png`}
              srcSet={`https://flagcdn.com/w40/gb.png 2x`}
              alt=""
            />
          </span>
        </Tag>
      </Link>
      {countryCode === "US" && (
        <Link disabled={isFetching} to={`${window.location.pathname}?country=IN${thisBrand}`}>
          <Tag
            className="tag-hover badge badge-light"
            style={{
              fontWeight: 500,
              marginBottom: "5px",
              border: searchCountry == "IN" ? "1px solid #007bff" : "1px solid #2f122e54",
            }}
          >
            <span style={{ display: "flex", alignItems: "center" }}>
              <span>India&nbsp;</span>
              <img
                style={{ width: "20px", objectFit: "contain" }}
                loading="lazy"
                src={`https://flagcdn.com/w20/in.png`}
                srcSet={`https://flagcdn.com/w40/in.png 2x`}
                alt=""
              />
            </span>
          </Tag>
        </Link>
      )}
    </>
  );
}

export default GetFilterCountries;
